// extracted by mini-css-extract-plugin
module.exports = {"image":"ProductCardImage_image__mtIAS"};